<template>
  <div class="page-title-area page-title-dark">
    <div class="container">
      <div class="page-title-content">
        <span class="sub-title">{{subTitle}}</span>
        <h1>{{heding}}</h1>
      </div>
    </div>

    <!-- Background Tech Elements (igual ao MainBanner) -->
    <div class="tech-background">
      <div class="grid-pattern"></div>
      <div class="geometric-shape shape-circle"></div>
      <div class="geometric-shape shape-square"></div>
      <div class="code-particle particle-1">&lt;/&gt;</div>
      <div class="code-particle particle-2">{ }</div>
      <div class="code-particle particle-3">API</div>
      <div class="gradient-orb orb-1"></div>
      <div class="gradient-orb orb-2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: ['subTitle', 'heding']
}
</script>

<style scoped>
.page-title-dark {
  position: relative;
  background: linear-gradient(135deg, #0a0a1a 0%, #16213e 50%, #1a1a2e 100%);
  padding: 150px 0 100px;
  overflow: hidden;
}

.page-title-content {
  position: relative;
  z-index: 2;
  text-align: center;
}

.sub-title {
  display: inline-block;
  padding: 8px 20px;
  background: rgba(109, 93, 252, 0.2);
  border: 1px solid rgba(109, 93, 252, 0.5);
  border-radius: 50px;
  color: #C5BFFF;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 20px;
  backdrop-filter: blur(10px);
}

.page-title-content h1 {
  color: #ffffff;
  font-size: 48px;
  font-weight: 700;
  line-height: 1.3;
  margin: 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  max-width: 800px;
  margin: 0 auto;
}

/* ===== TECH BACKGROUND ===== */
.tech-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
}

.grid-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
      linear-gradient(rgba(109, 93, 252, 0.05) 1px, transparent 1px),
      linear-gradient(90deg, rgba(109, 93, 252, 0.05) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridMove 20s linear infinite;
}

@keyframes gridMove {
  0% { transform: translate(0, 0); }
  100% { transform: translate(50px, 50px); }
}

.geometric-shape {
  position: absolute;
  opacity: 0.06;
  animation: floatShape 20s ease-in-out infinite;
}

.shape-circle {
  width: 200px;
  height: 200px;
  border: 3px solid #6D5DFC;
  border-radius: 50%;
  top: 20%;
  right: 10%;
}

.shape-square {
  width: 150px;
  height: 150px;
  border: 3px solid #4361EE;
  transform: rotate(45deg);
  bottom: 20%;
  left: 10%;
  animation-delay: 5s;
}

@keyframes floatShape {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(20px, -20px) rotate(180deg); }
}

.code-particle {
  position: absolute;
  color: rgba(109, 93, 252, 0.4);
  font-family: 'Courier New', monospace;
  font-weight: bold;
  font-size: 18px;
  animation: floatParticle 15s ease-in-out infinite;
}

.particle-1 {
  top: 20%;
  left: 15%;
}

.particle-2 {
  top: 60%;
  right: 20%;
  animation-delay: 3s;
}

.particle-3 {
  bottom: 30%;
  left: 25%;
  animation-delay: 6s;
}

@keyframes floatParticle {
  0%, 100% {
    transform: translateY(0) translateX(0);
    opacity: 0.4;
  }
  50% {
    transform: translateY(-30px) translateX(20px);
    opacity: 0.7;
  }
}

.gradient-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  animation: pulseOrb 10s ease-in-out infinite;
}

.orb-1 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(109, 93, 252, 0.15) 0%, transparent 70%);
  top: -100px;
  right: -100px;
}

.orb-2 {
  width: 350px;
  height: 350px;
  background: radial-gradient(circle, rgba(67, 97, 238, 0.12) 0%, transparent 70%);
  bottom: -100px;
  left: -100px;
  animation-delay: 5s;
}

@keyframes pulseOrb {
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
}

/* ===== RESPONSIVE ===== */
@media (max-width: 991px) {
  .page-title-dark {
    padding: 120px 0 80px;
  }

  .page-title-content h1 {
    font-size: 32px;
  }

  .code-particle,
  .geometric-shape {
    display: none;
  }
}

@media (max-width: 768px) {
  .page-title-content h1 {
    font-size: 28px;
  }
}
</style>